import { Directive, HostListener, Input, Self } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[capitalize]',
  standalone: true,
})
export class CapitalizeDirective {
  @Input('mode') mode?: 'first' | 'all' = 'first';

  constructor(@Self() private readonly ngModel: NgModel) {}

  @HostListener('blur', ['$event.target.value'])
  onBlur(value: string) {
    if (typeof value !== 'string') {
      return;
    }

    let capitalized: string;
    if (this.mode === 'all') {
      capitalized = value.toLocaleUpperCase();
    } else {
      capitalized = value.charAt(0).toLocaleUpperCase() + value.slice(1);
    }

    if (capitalized !== value) {
      this.ngModel.control.setValue(capitalized);
    }
  }
}
